import { createRouter } from "@tanstack/react-router";
import { queryClient } from "./lib/api/query-client";
import { routeTree } from "./routeTree.gen";

export const router = createRouter({
	routeTree,
	// The query client rides in the router context so `beforeLoad` guards can
	// call `ensureQueryData` — the session is fetched once, by the guard, and
	// the component tree reads it from the cache instead of fetching again.
	context: { queryClient },
	defaultPreload: "intent",
	defaultPreloadStaleTime: 0,
	scrollRestoration: true,
});

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
	interface StaticDataRouteOption {
		/**
		 * The page's content wrapper at wide widths (routes/_app.tsx <main>),
		 * one of the designer's own wrappers (admin.css / app.css). Default
		 * "page". See `CONTENT_WIDTH` in routes/_app.tsx for the full map.
		 */
		contentWidth?: ContentWidth;
		/** Space above the content (her page modifiers). Default "page". */
		contentTop?: ContentTop;
	}
}

/**
 * Her page wrappers, measured at 1366–2000px:
 *  - "page"     `.pg` — max 1240px including its 32px gutters, centred
 *               (content 1176px). View Records, record, Shortlist,
 *               E-Accreditation, Import, every Logistics page, and our admin
 *               pages that have no counterpart of hers.
 *  - "full"     `.pg--dash` — no cap; the Dashboard's art runs to the edge.
 * Register New Record is hers `.reg .lay` — 1120px including the gutters,
 * content 1056px — and draws that column itself (66rem, centred, in
 * register-flow), so it needs no value here.
 * (tokens.css `--wrap-results` 1240 / `--wrap-portal` 1180 / `--shell` 1320
 * belong to the public Games sites, not to any GMS page.)
 */
export type ContentWidth = "page" | "full";

/**
 * Space above the first block (desktop / tablet / phone):
 *  - "page"    `.pg`      28 / 24 / 16px — most pages.
 *  - "tabbed"  `.pg--sl`  20 / 20 / 16px — Shortlist, E-Accreditation and the
 *              Logistics pages, whose tab row or stats strip sits right under
 *              the top bar.
 */
export type ContentTop = "page" | "tabbed";
